// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }

var searchSubmit = SearchInput.prototype._onSubmit;
  
SearchInput.prototype._onSubmit = function(event, redirect) {
  searchSubmit.call(this, event, redirect);
  
  var term = unescape(Globals.currentTerm || '').replace("/", " ");
  var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
  
  var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
  
  if (isApiReturnedResult) {
    if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
      Utils.setWindowLocation(redirectUrl);
    } else {
      this.isChangePage = true;
      this.$searchForm[0].submit();
    }
  } 
}
  
})();